//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import theLoading from "~/components/common/loading/TheLoading.vue";
import theHeader from "~/components/kccam/user/layout/TheHeader.vue";
import theFooter from "~/components/kccam/user/layout/TheFooter.vue";

export default {
	components: {
		theLoading,
		theHeader,
		theFooter
	},
	data() {
		return {
			// scroll
			scroll: false,

			// 1:1 문의 안내 배너
			noticeBanner: false
		};
	},
	mounted() {
		if (!process.client) {
			return;
		}
		// 스크롤 관련
		window.addEventListener("scroll", this.onScroll);

		// 반응형 적용할 html 구분 ( 관리자 아닌 사용자에만 적용. )
		document.querySelector("html").classList.add("responsive-html");

		// 1:1 문의 안내 배너
		this.noticeBannerVisible(this.$route.path);
	},
	beforeDestroy() {
		if (!process.client) {
			return;
		}
		// 스크롤 관련
		window.removeEventListener("scroll", this.onScroll);
	},
	computed: {
		loadingIndicator() {
			return this.$nuxt.$root.$loading.percent;
		}
	},
	watch: {
		$route() {
			// 1:1 문의 안내 배너
			this.noticeBannerVisible(this.$route.path);
			// 방문 이력 저장
			this.insertHistView( this.$route.fullPath );
		}
	},
	methods: {
		// 스크롤 top 으로
		goTop() {
			animateScrollTo(0);
		},
		/**
		 * 방문 이력을 남깁니다.
		 */
		async insertHistView( url ) {
			if ( this.$common.isEmpty( url ) ) {
				return;
			}
			const HIST_VIEW_INSERT_URL = this.$urlConstant.API_URL_PREFIX.HIST_VISIT
										+ this.$urlConstant.API_URL_SUFFIX.HIST_VISIT.INSERT;
			let visitPageName = this.getVisitPageName( this.$route.fullPath );
			let info = {
				visitURL        : this.$route.fullPath,
				visitPageName    : visitPageName,
			}
			await this.$axios.post( HIST_VIEW_INSERT_URL, info ).then( res => {
				// console.log( res );
			}).catch( error => {
				console.log( error );
			});
		},
		getVisitPageName( url ) {
			if( this.$common.isEmpty( url ) ) {
				return '-';
			}
			let urlPrefixObj = this.$urlConstant.MENU_URL_PREFIX;
			let urlSuffixObj = this.$urlConstant.MENU_URL_SUFFIX;
			let str = '';
			const _self = this;
			if ( url.indexOf( "kccam/user/main/user_main") != -1 ) {
				str += "메인 페이지";
				return str;
			}
			// 1뎁스 만들기 ( prefix )
			for( let preFixKey in urlPrefixObj ) {
				if ( url.indexOf( urlPrefixObj[ preFixKey ]) !=-1 ) {
					let matchKey = preFixKey.split('USER_')[1];
					str += _self.$amConstant.MENU_NAME[matchKey].TITLE;
					break;
				}
			}
			// 2뎁스 만들기 ( suffix )
			for( let suffixKey in urlSuffixObj ) {
				let deepObj = urlSuffixObj[suffixKey];
				for( let deepKey in deepObj ) {
					let deepValue = deepObj[deepKey];
					if ( typeof( deepValue ) == 'string' ) {
						let compareStr = deepValue.split('?').length > 1 ? deepValue.split('?')[0]
																				: deepValue.split('?')[0];

						if ( url.indexOf( compareStr ) != -1 ) {
							if ( _self.$common.isEmpty(_self.$amConstant.MENU_NAME[suffixKey] ) ) {
								break;
							}
							if( typeof _self.$amConstant.MENU_NAME[suffixKey][deepKey] != 'undefined') {
								str += ' > ';
								str += _self.$amConstant.MENU_NAME[suffixKey][deepKey];
							}
						}
					}
					else if ( typeof( deepValue ) == 'object' ) {
						if ( url.indexOf( "newsroom" ) != -1 ) {
							str += ' > ';
							str += "뉴스룸";
						}

					}
				}
			}
			return str;
		},

		// 스크롤 관련
		onScroll(e) {
			// let scrollPosition = window.scrollY || document.documentElement.scrollTop;

			let scrollPosition = document.querySelector("html").scrollTop;
			let headerHeight = document.getElementById("header").scrollHeight;

			if (scrollPosition > headerHeight) {
				this.scroll = true;
			} else {
				this.scroll = false;
			}
		},

		// 1:1 문의 안내 배너
		noticeBannerVisible(path) {
			if (-1 < path.indexOf("/customerSupport_inquiry")) {
				this.noticeBanner = true;
			} else {
				this.noticeBanner = false;
			}
		}
	}
};
